import { createContext, useCallback, useEffect, useReducer, useRef } from 'react';

import classNames from 'classnames';

import ComponentType from '../../types/Component';
import DeviceType from '../../types/Device';
import getDeviceType from '../../utils/getDeviceType';

import deviceTypeReducer from './reducer';
import { DeviceTypeProviderDispatcher } from './types';

export const DeviceTypeProviderContext = createContext({
	state: {} as DeviceType,
	dispatch: {} as DeviceTypeProviderDispatcher,
});

const initialState: DeviceType = getDeviceType(window.navigator.userAgent);

const DeviceTypeProvider: ComponentType<any> = ({ children }) => {
	const [state, dispatch] = useReducer(deviceTypeReducer, initialState);

	const toRef = useRef<any>(0);

	const _handleResize = useCallback(() => {
		clearTimeout(toRef.current);
		toRef.current = setTimeout(() => {
			const deviceType = getDeviceType();
			dispatch({ type: 'set-device-type', deviceType });
		}, 300);
	}, []);

	useEffect(() => {
		window?.addEventListener('resize', _handleResize);

		return () => {
			window?.removeEventListener('resize', _handleResize);
		};
	}, []);

	return (
		<div
			id="device-type-selector"
			className={classNames({
				'is-mobile': state?.isMobile,
				'is-desktop': state?.isDesktop,
				'is-tablet': state?.isTablet,
			})}>
			<DeviceTypeProviderContext.Provider value={{ state, dispatch }}>
				{children}
			</DeviceTypeProviderContext.Provider>
		</div>
	);
};

export default DeviceTypeProvider;
